import { call, put, select } from "redux-saga/effects";

import axios from "../../config/axiosConfig";
import { GET_USER_FOUND,LOGOUT_SUCCESS,GET_USER_NOT_FOUND,LOGOUT_ERROR,FETCH_BALANCE_SUCCESS,FETCH_BALANCE_FAILED, CONNECT_SUCCESS, CONNECT_FAILED, TELEGRAM_SIGNIN_FAILED, TELEGRAM_SIGNIN_SUCCESS, SILENT_LOGIN_SUCCESS, SILENT_LOGIN_FAILED, CONNECT_ACCOUNT_SUCCESS, CONNECT_ACCOUNT_FAILED } from "../actions/authActions";
import { TOAST_SHOW } from "../actions/toastActions";
import { removeCookie, setCookie } from "../../utils/functions";
import { requestAnalyticsEventAction } from "../actions/eventsActions";
import { ERROR_CODES } from '../../constants/errorCodes';
import { setSilentLoginFlag, clearSilentLoginFlag } from "../../utils/deviceUtils";
import { contentScopeChangedAction } from "../actions/contentCacheActions";
import { getUserMessages } from "../actions/messageActions";
import { contentCacheRepository } from "../../services/contentCacheRepository";
import { userIdFromToken } from "../../services/offlineGames/gameFiles";
import { transferOfflineGames } from "../../services/offlineGames/registry";

const buildSilentLoginPayload = (userData) => ({
	user: {
		id: userData.id,
		username: userData.username,
		email: userData.email,
		avatar: userData.avatar,
		balance: userData.balance,
		xp: userData.xp,
		rank: userData.rank,
		walletid: userData.walletid,
		wallettype: userData.wallettype
	},
	balance: userData.balance,
	played: userData.played || [],
	ad_reward_coins: userData.ad_reward_coins || 0,
	type: userData.type
});

function* handleSilentLoginSuccess(userData, action, authHeaders) {
	console.log('[Auth:appLogin] success — userType:', userData?.type, '| userId:', userData?.id, '| username:', userData?.username, '| tokenChanged:', authHeaders?.['x-access-token'] !== userData?.accessToken);

	localStorage.setItem("token", userData.accessToken);
	setSilentLoginFlag(true);

	yield put(contentScopeChangedAction(userData?.id));
	yield put({
		type: SILENT_LOGIN_SUCCESS,
		payload: buildSilentLoginPayload(userData),
		token: userData.accessToken,
	});

	const expirationTime = new Date();
	expirationTime.setTime(expirationTime.getTime() + (365 * 24 * 60 * 60 * 1000));
	setCookie('sessionExists', true, expirationTime);

	let userType = userData.type;
	if (userType === 'Registered') {
		yield put(requestAnalyticsEventAction({
			eventType: "request",
			event: "pageview",
			event_value: "User_Anonymous_Login_New",
			event_parent: "page",
			desc: "New anonymous user created via /app_login"
		}));
	} else {
		yield put(requestAnalyticsEventAction({
			eventType: "request",
			event: "pageview",
			event_value: "User_Anonymous_Login_Returning",
			event_parent: "page",
			desc: "Returning anonymous user via /app_login"
		}));
	}

	if (action?.successCallback) {
		action.successCallback();
	}
}



export function* LoginSaga(action) { 
	try {
		const response = yield call(axios.post, `social_login`, action.payload);

		if (response?.status === 200) {
			console.log(response);
				
			/*----------START: UTMS Analytics-------- */
			let userType = response?.data?.type;
			if(userType==='Registered'){
				yield put(requestAnalyticsEventAction({ eventType:"request", event:"pageview", event_value:"User_Connect_New",  event_parent:"page", desc:"Fires whenever a user is created in the system for the first time" })); 
			}else{
				yield put(requestAnalyticsEventAction({ eventType:"request", event:"pageview", event_value:"User_Connect_Existing",  event_parent:"page", desc:"Fires whenever a user logs in the system NOT for the first time" })); 
			}
			/*----------END: UTMS Analytics-------- */
			yield put(requestAnalyticsEventAction({ eventType:"request", event:"pageview", event_value:"WalletConnected",  event_parent:"page", desc:"WalletConnected" }));

			yield put(requestAnalyticsEventAction(
				{ eventType:"request", event:"pageview", event_value:"Wallet_Connect_Confirmed_" + userType,  event_parent:"page", desc:"Analytics Page View" }
			)); 
			
			localStorage.setItem("token", response?.data?.accessToken);
			const responseLogin = yield call(axios.get, `login`);
			if (responseLogin?.status === 200) {
				yield put(contentScopeChangedAction(responseLogin?.data?.user?.id));
				yield put({
					type: GET_USER_FOUND,
					payload: responseLogin?.data,
					token: response?.data?.accessToken
						? response?.data?.accessToken
						: `testLogin-${action?.payload?.loginType}`,
				});
				//yield put({ type: TOAST_SHOW,payload: { message: "Login Successfully!", severity: "Success",show: true} });

				/**Start: Set cookie code used to logout user after some specific time */
				const expirationTime = new Date();
			    //expirationTime.setTime(expirationTime.getTime() + (2 * 60 * 1000)); // 5 minutes in milliseconds 
				expirationTime.setTime(expirationTime.getTime() + (1 * 24 * 60 * 60 * 1000)); // 1 day in milliseconds 
				setCookie('sessionExists',true,expirationTime) //name,value,expirationtime
				/**End: Set cookie code used to logout user after some specific time */
				
				

				if(action?.payload?.loginType ==='discord'){
					window.location.replace('/')
				}
				
			}
		}
	} catch (e) {
		yield put({
			type: TOAST_SHOW,
			payload: { message: `${ERROR_CODES.E1001}: Something went wrong please try again`, severity: "Danger", show: true},
		});
		yield put({ type: GET_USER_NOT_FOUND });
	}
}
 

export function* LogoutSaga(action) {
	const outgoingUserScope = yield select((state) => String(state?.Auth?.user?.id || "guest"));
	try {
		const response = yield call(axios.get, "logout");

		if (response?.status === 200) {
			yield call([contentCacheRepository, contentCacheRepository.clearUserScope], outgoingUserScope);
			yield put(contentScopeChangedAction("guest"));
			yield put({ type: LOGOUT_SUCCESS });
			/**Start: Remove cookie on logout */
			removeCookie('sessionExists');
			/**End: Remove cookie on logout */

			if(action?.successcallback){ //To disconnect web3login 
				let successcallback = action?.successcallback;
				successcallback();
			}
			//yield put({ type: TOAST_SHOW, payload: { message: "Logout Successfully!", severity: "Success", show: true } });
		}
	} catch (e) {
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E1002}: Something went wrong please try again`, severity: "Danger", show: true} });
		yield put({ type: LOGOUT_ERROR });
	}
}

 
  

export function* fetchBalanceSaga(action) {  
	try {
		const response = yield call(axios.get, `/api/balance?t=${Date.now()}`); 
		if (response?.status === 200) { 
			yield put({ type:FETCH_BALANCE_SUCCESS, payload: response?.data?.balance }); 
			// The balance request is what creates today's daily reward on the server, so
			// the messages fetched when the page opened can miss it. Fetch them again (AK-243).
			if (!localStorage.getItem("isFromCustomCategory")) {
				yield put(getUserMessages({ force: true }));
			}
		} 
	} catch (e) {
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E1005}: Something went wrong please try again`, severity: "Danger", show: true, } });    
		yield put({ type: FETCH_BALANCE_FAILED });
	}
}

export function* ConnectSaga(action) {
	try { 
		const response = yield call(axios.post, `connect`, action.payload);  

		if (response?.status === 200) {
			localStorage.setItem("token", response?.data?.accessToken);
			yield put(contentScopeChangedAction(response?.data?.id));
			yield put({
				type: CONNECT_SUCCESS,
				payload: response?.data,
				token: response?.data?.accessToken
					? response?.data?.accessToken
					: `testLogin-${action?.payload?.wallet_type}`,
			});

			/**Start: Set cookie code used to logout user after some specific time */
			const expirationTime = new Date();
			//expirationTime.setTime(expirationTime.getTime() + (2 * 60 * 1000)); // 5 minutes in milliseconds 
			expirationTime.setTime(expirationTime.getTime() + (1 * 24 * 60 * 60 * 1000)); // 1 day in milliseconds 
			setCookie('sessionExists',true,expirationTime) //name,value,expirationtime
			/**End: Set cookie code used to logout user after some specific time */
			yield put({ type: TOAST_SHOW,payload: { message: "Login Successfully!", severity: "Success",show: true} }); 

			if(action?.successCallback){
				let successCallbackHandle = action?.successCallback;
				successCallbackHandle();
			}
			 
			/*----------START: UTMS Analytics-------- */
			let userType = response?.data?.type; 
			if(userType==='Registered'){
				yield put(requestAnalyticsEventAction({ eventType:"request", event:"pageview", event_value:"User_Connect_New",  event_parent:"page", desc:"Fires whenever a user is created in the system for the first time" })); 
			}else{
				yield put(requestAnalyticsEventAction({ eventType:"request", event:"pageview", event_value:"User_Connect_Existing",  event_parent:"page", desc:"Fires whenever a user logs in the system NOT for the first time" })); 
			}
			/*----------END: UTMS Analytics-------- */
			yield put(requestAnalyticsEventAction({ eventType:"request", event:"pageview", event_value:"WalletConnected",  event_parent:"page", desc:"WalletConnected" })); 

			yield put(requestAnalyticsEventAction(
				{ eventType:"request", event:"pageview", event_value:"Wallet_Connect_Confirmed_" + userType,  event_parent:"page", desc:"Analytics Page View" }
			)); 
		}
	} catch (e) {
		console.log('connect failed - disconnect');

		if (action.payload?.failureCallback){
			console.log("call disconnect");
			let failureCallbackHandle = action?.payload?.failureCallback;
			failureCallbackHandle();
		}
		
		// Clear any stored tokens
		localStorage.removeItem('token');
		localStorage.removeItem('web3-token');
		
		
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E1003}: Something went wrong please try again`, severity: "Danger", show: true} });
		yield put({ type: CONNECT_FAILED });
	}
}

export function* TelegramSignSaga(action) {
	try { 
		const response = yield call(axios.post, `tg_login`,action.payload);  
		if (response?.status === 200) {
			localStorage.setItem("token", response?.data?.accessToken);  
			const responseLogin = yield call(axios.get, `login`);
			if (responseLogin?.status === 200) {
				yield put(contentScopeChangedAction(responseLogin?.data?.user?.id));
				yield put({
					type: TELEGRAM_SIGNIN_SUCCESS,
					payload: responseLogin?.data,
					token: response?.data?.accessToken ,
				});
 
				/**Start: Set cookie code used to logout user after some specific time */
				const expirationTime = new Date();
			    //expirationTime.setTime(expirationTime.getTime() + (2 * 60 * 1000)); // 5 minutes in milliseconds 
				expirationTime.setTime(expirationTime.getTime() + (1 * 24 * 60 * 60 * 1000)); // 1 day in milliseconds 
				setCookie('sessionExists',true,expirationTime) //name,value,expirationtime
				/**End: Set cookie code used to logout user after some specific time */
				
				/*----------START: UTMS Analytics-------- */
				let userType = responseLogin?.data?.user?.type;
				if(userType==='Registered'){
					yield put(requestAnalyticsEventAction({ eventType:"request", event:"pageview", event_value:"User_Connect_New",  event_parent:"page", desc:"Fires whenever a user is created in the system for the first time" })); 
				}else{
					yield put(requestAnalyticsEventAction({ eventType:"request", event:"pageview", event_value:"User_Connect_Existing",  event_parent:"page", desc:"Fires whenever a user logs in the system NOT for the first time" })); 
				}
				/*----------END: UTMS Analytics-------- */ 
			}
		}
	} catch (e) {
		console.log(`369---->err telegram`,e)
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E1004}: Something went wrong please try again`, severity: "Danger", show: true} });
		yield put({ type: TELEGRAM_SIGNIN_FAILED });
	}
}

/**
 * Silent Login Saga
 * Handles automatic anonymous user authentication via /app_login endpoint
 * This is called automatically on app init for users without explicit login
 * 
 * Uses actual server endpoint: POST /app_login
 * Headers: x-client-key (new user) or x-access-token (returning user)
 * Response: { id, username, email, avatar, accessToken, balance, type, ... }
 * 
 * Server automatically:
 * - Creates anonymous user with random username (e.g., "brave-fox-456")
 * - Generates fake email (username@akedo.fake)
 * - Returns JWT token that identifies this specific user
 * - Reuses existing user if x-access-token is provided
 */
export function* SilentLoginSaga(action) {
	try {
		console.log('[Silent Login Saga] Starting anonymous authentication via /app_login');
		
		// Import auth utilities
		const { getAuthHeaders } = yield import('../../utils/clientAuthUtils');
		
		// Get appropriate headers (x-client-key or x-access-token)
		const authHeaders = getAuthHeaders();
		
		const authMethod = authHeaders['x-access-token'] ? 'RETURNING_USER (token)' : 'NEW_USER (encrypted-key)';
		console.log('[Auth:appLogin] method:', authMethod);
		
		// Call /app_login endpoint with proper headers
		const response = yield call(axios.post, `/app_login`, {}, {
			headers: authHeaders,
			skipAuthRefresh: true,
		});
		
		if (response?.status === 200) {
			yield* handleSilentLoginSuccess(response?.data, action, authHeaders);
		}
	} catch (e) {
		const httpStatus = e?.response?.status;
		const serverMsg = e?.response?.data?.message || e?.response?.data || e?.message;
		console.error('[Auth:appLogin] FAILED — httpStatus:', httpStatus, '| serverMsg:', serverMsg, '| fullError:', e);
		
		// Only clear the token when the server explicitly rejected it (401/403).
		// A network blip or 5xx should leave the token intact so the user stays identified
		// on the next visit. Unconditionally removing it here was causing valid returning
		// users to lose their session and see "Something went wrong".
		if (httpStatus === 401 || httpStatus === 403) {
			console.warn('[Auth:appLogin] Token rejected by server (', httpStatus, ') — clearing token');
			localStorage.removeItem('token');
			localStorage.removeItem('web3-token');

			try {
				const { getAuthHeaders } = yield import('../../utils/clientAuthUtils');
				const retryAuthHeaders = getAuthHeaders();
				console.log('[Auth:appLogin] retrying as NEW_USER after rejected stored token');
				const retryResponse = yield call(axios.post, `/app_login`, {}, {
					headers: retryAuthHeaders,
					skipAuthRefresh: true,
				});

				if (retryResponse?.status === 200) {
					yield* handleSilentLoginSuccess(retryResponse?.data, action, retryAuthHeaders);
					return;
				}
			} catch (retryError) {
				console.error(
					'[Auth:appLogin] recovery retry FAILED — httpStatus:',
					retryError?.response?.status,
					'| serverMsg:',
					retryError?.response?.data?.message || retryError?.response?.data || retryError?.message
				);
			}
		} else {
			console.warn('[Auth:appLogin] Non-auth error (', httpStatus || 'network', ') — keeping token intact for next visit');
		}
		
		yield put({ 
			type: TOAST_SHOW, 
			payload: { 
				message: `Authentication failed. Please try explicit login.`, 
				severity: "Warning", 
				show: true 
			} 
		});
		yield put({ type: SILENT_LOGIN_FAILED });
	}
}

/**
 * Connect Account Saga
 * Upgrades an anonymous user (from /app_login) to a connected account (Google/Discord)
 * Merges existing anonymous user data with the new connected account
 * 
 * Expected API endpoint: POST /connect_account
 * Headers: x-access-token (current anonymous user token)
 * Payload: { email, name, profileImage, verifier, verifierId, token }
 * 
 * IMPORTANT: Server must:
 * - Identify anonymous user by x-access-token header (current JWT)
 * - Merge all data (balance, leaderboards, purchases, games, plays)
 * - Update user to connected account
 * - Return merged user data with new token
 * - NO data deletion or reset
 */
export function* ConnectAccountSaga(action) {
	try {
		console.log('[Connect Account Saga] Upgrading anonymous user to connected account');
		
		// Get current token to identify anonymous user
		const currentToken = localStorage.getItem('token');
		
		if (!currentToken) {
			console.error('[Connect Account Saga] No current token found');
			yield put({ 
				type: TOAST_SHOW, 
				payload: { 
					message: 'Authentication error. Please refresh and try again.', 
					severity: "Danger", 
					show: true 
				} 
			});
			yield put({ type: CONNECT_ACCOUNT_FAILED });
			return;
		}
		
		// Call /connect_account endpoint with current token in header
		const response = yield call(axios.post, `/connect_account`, action.payload, {
			headers: {
				'x-access-token': currentToken
			}
		});
		
		if (response?.status === 200) {
			console.log('[Connect Account Saga] Account connection successful');
			
			// Clear anonymous login flag since user is now connected
			clearSilentLoginFlag();
			
			// Update token
			localStorage.setItem("token", response?.data?.accessToken);
			// The guest's downloaded games come along, like the rest of their data.
			transferOfflineGames(userIdFromToken(currentToken), userIdFromToken(response?.data?.accessToken));
			
			// Get full user profile
			const responseLogin = yield call(axios.get, `login`);
			
			if (responseLogin?.status === 200) {
				yield put(contentScopeChangedAction(responseLogin?.data?.user?.id));
				yield put({
					type: CONNECT_ACCOUNT_SUCCESS,
					payload: responseLogin?.data,
					token: response?.data?.accessToken,
				});
				
				/**Start: Set cookie for connected account - NO AUTO-LOGOUT */
				const expirationTime = new Date();
				expirationTime.setTime(expirationTime.getTime() + (365 * 24 * 60 * 60 * 1000)); // 1 year
				setCookie('sessionExists', true, expirationTime);
				/**End: Set cookie */
				
				yield put({ 
					type: TOAST_SHOW, 
					payload: { 
						message: "Account connected successfully! Your data has been preserved.", 
						severity: "Success", 
						show: true 
					} 
				});
				
				/*----------START: UTMS Analytics-------- */
				yield put(requestAnalyticsEventAction({ 
					eventType: "request", 
					event: "pageview", 
					event_value: "Anonymous_User_Upgraded_To_Connected",  
					event_parent: "page", 
					desc: "Anonymous user upgraded to connected account" 
				}));
				/*----------END: UTMS Analytics-------- */
				
				// Call success callback if provided
				if (action?.successCallback) {
					action.successCallback();
				}
			}
		}
	} catch (e) {
		console.error('[Connect Account Saga] Account connection failed:', e);
		
		// Check if it's a conflict error (account already connected)
		if (e.response?.status === 409) {
			yield put({ 
				type: TOAST_SHOW, 
				payload: { 
					message: 'This account is already connected to another user.', 
					severity: "Warning", 
					show: true 
				} 
			});
		} else {
			yield put({ 
				type: TOAST_SHOW, 
				payload: { 
					message: `Failed to connect account. Please try again.`, 
					severity: "Danger", 
					show: true 
				} 
			});
		}
		
		yield put({ type: CONNECT_ACCOUNT_FAILED });
	}
}
 
